/* eslint-disable */
import axios from "axios";

// Módulo para obtener buses
const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/bookings/";


async function toggleAssignBus(type, bookingData, dispatch, commit, thiz) {
    return axios
        .patch(baseUrl + bookingData.id + "/" + type +"/", bookingData.newData)
        .then(
            response => {
                if (bookingData.newData.bus_type == "Excursion") {
                    commit("bookings/UPDATE_BOOKING_BY_ACTIVITY", {
                        bookingData: response.data,
                        operation: type,
                        busType: 'Excursion'
                    }, {
                        root: true
                    });
                    commit("bookings/UPDATE_BOOKING_BY_BUS", {
                        bookingData: response.data,
                        isPickup: false,
                        busType: 'Excursion',
                        operation: type,
                    }, {
                        root: true
                    });
                    // FIXME: go to loadExcursionBuses method
                    if ( bookingData.loadData ) {
                        dispatch("buses/loadExcursionBuses", {}, {root: true})
                        //dispatch("bookings/loadBookingsByExcursionBus", {root: true})
                       
                    }
                } else if (bookingData.newData.bus_type == "Pickup") {
                    commit("bookings/UPDATE_BOOKING_BY_STOP", {
                        bookingData: response.data,
                        busType: 'Pickup',
                        operation: type,
                    }, {
                        root: true
                    });

                    commit("bookings/UPDATE_BOOKING_BY_BUS", {
                        bookingData: response.data,
                        isPickup: true,
                        busType: 'Pickup',
                        operation: type,
                    }, {
                        root: true
                    });
                    
                    if ( bookingData.loadData ) {
                        dispatch("buses/loadPickupBuses", {}, {root: true})
                        //dispatch("bookings/loadBookingsByPickupBus", {root: true})
                        //dispatch("bookings/loadBookingsByExcursionBus", {root: true})
                        
                    }
                } else if (bookingData.newData.bus_type == "Return") {
                    commit("bookings/UPDATE_BOOKING_BY_STOP", {
                        bookingData: response.data,
                        busType: 'Return',
                        operation: type,
                    }, {
                        root: true
                    });

                    commit("bookings/UPDATE_BOOKING_BY_BUS", {
                        bookingData: response.data,
                        isPickup: true,
                        busType: 'Return',
                        operation: type,
                    }, {
                        root: true
                    });
                    
                    if ( bookingData.loadData ) {
                        dispatch("buses/loadReturnBuses", {}, {root: true})
                        //dispatch("bookings/loadBookingsByPickupBus", {root: true})
                        //dispatch("bookings/loadBookingsByExcursionBus", {root: true})
                        
                    }
                }

            },
            err => {
                console.log(err);
            }
        );
}

const actions = {
    // Assign bus from booking
    assignBus({
        commit,
        dispatch
    }, bookingData) {
        // FIXME await
        return toggleAssignBus('assign_bus', bookingData, dispatch, commit, this)
    },

    // Deassign bus from booking
    deassignBus({
        commit,
        dispatch,
    }, bookingData) {
        // FIXME await
        return toggleAssignBus('deassign_bus', bookingData, dispatch, commit, this)
    },
    // Make the bus to be deleted in all reservations to which it is assigned to null or change it to another bus selected in all these reservations
    async moveAllBuses({
        commit
    }, payload) {
        await axios.post(baseUrl + "move_all/", payload).then(
            response => {
                if (payload.bus_type == "Excursion") {
                    commit("bookings/UPDATE_BOOKINGS_BY_ACTIVITY", {
                        bookingData: response.data
                    }, {
                        root: true
                    });
                } else {
                    commit("bookings/UPDATE_BOOKINGS_BY_BUS", {
                        bookingData: response.data
                    }, {
                        root: true
                    });
                    commit("bookings/UPDATE_BOOKINGS_BY_STOP", {
                        bookingData: response.data
                    }, {
                        root: true
                    });
                }
            },
            err => {
                console.log(err);
            }
        );
    },
    // Assign a stop to a booking
    async assignStop({
        commit,
        getters,
        dispatch
    }, payload) {
        commit("ISLOADING", ["default", true], {
            root: true,
          });
        await axios
            .patch(baseUrl + payload.id + "/assign_stop/", payload.data)
            .then(
                response => {
                    commit("bookings/ADD_BOOKING", { bookingData: response.data }, { root: true });
            
                    commit("bookings/DELETE_BOOKING_UNASSIGNED", payload.id, {root: true})
                    
                    if ( this.getters.activeTab === 'Excursions') {
                        dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'}, { root: true })
                    } else if ( this.getters.activeTab === 'Pickups') {
                        
                    }

                    commit("ISLOADING", ["default", false], {
                        root: true,
                    });
                },
                err => {
                    console.log(err);
                }
            );
    },

    // test closing bus
    async closingTest({
        commit, dispatch
    }, id) {
        commit("ISLOADING", ["booking", true], {root: true,});
        return axios
            .post(baseUrl + id + "/test_override/")
            .then(response => {
                return response.data
            })
            .finally( () => {
                commit("ISLOADING", ["booking", false], {root: true,});
            });
    },

    // Copy Bus excursion to Pickup
    async closeBus({
        commit,
        dispatch
    }, id) {
        commit("ISLOADING", ["booking", true], {root: true,});
        return axios
            .post(baseUrl + id + "/copy_excursion_to_pickup/")
            .then(response => {
                const bookingData = {
                    date: this.getters.filterDate,
                    group: this.getters.filterGroup,
                };

                if ( this.getters.activeTab === 'Excursions') {
                    const busData = {
                        date: this.getters.filterDate,
                        group: this.getters.filterGroup,
                        bus_type: 'Excursions'
                    };
                    return Promise.all(
                        [
                            dispatch("bookings/loadBookingsByExcursionBus", bookingData, { root: true }),
                            dispatch("bookings/loadBookingsByActivity", bookingData, { root: true }),
                            dispatch("buses/loadExcursionBuses", busData, { root: true }),
                            dispatch("buses/busesPath", {}, {root: true})
                        ]
                    )
                    
                } else if ( this.getters.activeTab === 'Pickups') {
                    const busData = {
                        date: this.getters.filterDate,
                        group: this.getters.filterGroup,
                        bus_type: 'Pickups'
                    };
                    return Promise.all(
                        [
                            dispatch("bookings/loadBookingsByExcursionBus", bookingData, { root: true }),
                            dispatch( "bookings/loadBookingsByPickupBus", bookingData, { root: true }),
                            dispatch("buses/loadPickupBuses", busData, { root: true })
                        ]   
                    )
                }
            })
        .finally( () => {
            commit("ISLOADING", ["booking", false], {root: true,});
        });
    },

    

    // Reset all assigned buses by type
    async resetAssignedBusesByType({
        state,
        getters,
        commit,
        dispatch
    }, data) {
        // commit("ISLOADING", ["booking", false], {
        //     root: true,
        // });
        await axios.get(`${baseUrl}reset_bus_by_type/?day=${data.date}&bus_type=${data.bus_type}&activity_group_id=${this.getters.filterGroup}`);


        const path = data.bus_type;

        const busData = {
            date: this.getters.filterDate,
            group: this.getters.filterGroup,
            bus_type: path
        };

        const bookingData = {
            date: this.getters.filterDate,
            group: this.getters.filterGroup,
        };

        path == "Excursion" ?
            dispatch("buses/loadExcursionBuses", busData, {
                root: true
            }) :
            dispatch("buses/loadPickupBuses", busData, { root: true});

        if (path == "Excursion") {
            dispatch("bookings/loadBookingsByActivity", bookingData, {root: true});
            dispatch("buses/loadExcursionBuses", busData, {root: true})
        } else if ( path == 'Pickup') {
            dispatch("buses/loadPickupBuses", busData, { root: true});
            dispatch("bookings/loadBookingsByExcursionBus", bookingData, {root: true});
            dispatch("bookings/loadBookingsByPickupBus", bookingData, {root: true});
            dispatch("bookings/loadBookingsByStop", bookingData, {root: true});
        } else if ( path == 'Return') {
            dispatch("buses/loadReturnBuses", busData, {root: true})
            dispatch("bookings/loadBookingsByReturnBus", bookingData, {root: true});
            dispatch("bookings/loadBookingsByStop", bookingData, {root: true});
        }
        dispatch("buses/busesPath", {}, {root: true})
    },

    async resetAllBuses({
        state,
        commit,
        dispatch
    }, data) {
        await axios.get(`${baseUrl}reset_all_buses/?day=${this.getters.filterDate}&activity_group_id=${this.getters.filterGroup}`)

        // get fresh data
        dispatch("buses/loadExcursionBuses", {}, { root: true })
        dispatch("buses/loadPickupBuses", {}, { root: true})
        dispatch("buses/loadReturnBuses", {}, {root: true})
        dispatch("bookings/loadBookingsByActivity", {}, { root: true })
        //dispatch("bookings/loadBookingsByExcursionBus", {}, { root: true } )
        //dispatch("bookings/loadBookingsByPickupBus", {}, { root: true })
        //dispatch("bookings/loadBookingsByStop", false, { root: true })
        //dispatch("buses/busesPath", {}, {root: true})
    },

    async emptyBus({
        commit, dispatch
    }, data) {
        await axios
            .post(
                baseUrl + 'reset_bus_bus_type/',
                data
            ).then(response => {
                //dispatch("buses/loadExcursionBuses", {}, { root: true })
                //dispatch("buses/loadPickupBuses", {}, { root: true})
                dispatch("layout/loadData", {reset: false},{ root: true})
            })
        console.log('empty bus ', data)
        
    }


};

export default {
    namespaced: true,
    actions
};